<template>
  <div
    v-if="show"
    class="modal-backdrop"
  >
    <div class="modal">
      <button
        class="close-btn"
        @click="$emit('close')"
      >
        ×
      </button>
      <iframe
        :src="url"
        frameborder="0"
        class="iframe-content"
      />
    </div>
  </div>
</template>
  
  <script>
  export default {
    props: {
      url: String,
      show: Boolean,
    },
  };
  </script>
  
  <style scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .modal {
    background: #fff;
    width: 80%;
    height: 80%;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }
  
  .iframe-content {
    width: 100%;
    height: 100%;
    border: none;
  }
  
  .close-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 24px;
    background: none;
    border: none;
    cursor: pointer;
  }
  </style>
  